import SportsSoccerIcon from "@mui/icons-material/SportsSoccer";
import SportsFootballIcon from "@mui/icons-material/SportsFootball";
import SportsBaseballIcon from "@mui/icons-material/SportsBaseball";
import SportsBasketballIcon from "@mui/icons-material/SportsBasketball";
import SportsCricketIcon from "@mui/icons-material/SportsCricket";
import SportsGolfIcon from "@mui/icons-material/SportsGolf";
import SportsHockeyIcon from "@mui/icons-material/SportsHockey";
import SportsMmaIcon from "@mui/icons-material/SportsMma";
import SportsRugbyIcon from "@mui/icons-material/SportsRugby";
import SportsTennisIcon from "@mui/icons-material/SportsTennis";
import slugify from "@sindresorhus/slugify";

export const sportsOptions = [
  "Am. Football",
  "Aussie Rules",
  "Baseball",
  "Basketball",
  "Boxing",
  "Cricket",
  "Golf",
  "Ice Hockey",
  "Mixed Martial Arts",
  "Rugby League",
  "Rugby Union",
  "Soccer",
  "Tennis",
];

export const formatRate = (rate, threeDecimals = false, na = false) => {
  // If rate is not a number, return an empty string
  if (rate === undefined || rate === null || rate === "") {
    if (na) {
      return "N/A";
    }
    return "";
  }

  // Convert to a number
  const number = Number(rate);

  // Floor the number to two decimal places
  const flooredNumber = Math.floor(number * 1000) / 1000;

  // Format the number to ensure it always has two decimal places
  return flooredNumber.toFixed(threeDecimals ? 3 : 2);
};

export const getBookieLogoUrl = (bookie_name) => {
  // Return empty string if no bookie name provided
  if (!bookie_name) return "";

  try {
    const url = `https://bonusbank.com.au/bookies/${slugify(bookie_name, {
      decamelize: false,
    })}.png`;

    // Create a dummy image to test loading
    const img = new Image();
    img.onerror = () => ""; // Return empty string on error
    img.src = url;

    return url;
  } catch (error) {
    return ""; // Return empty string if any error occurs
  }
};

export const eventTypes = [
  { value: "match", label: "Match" },
  { value: "tournament", label: "Tournament" },
  { value: "race", label: "Race" },
];

export const oddsFormats = [
  { value: "decimal", label: "Decimal" },
  { value: "fractional", label: "Fractional" },
  { value: "american", label: "American" },
];

export const sportsIcons = {
  "Am. Football": <SportsFootballIcon />,
  "Aussie Rules": <SportsRugbyIcon />,
  Baseball: <SportsBaseballIcon />,
  Basketball: <SportsBasketballIcon />,
  Boxing: <SportsMmaIcon />,
  Cricket: <SportsCricketIcon />,
  Golf: <SportsGolfIcon />,
  "Ice Hockey": <SportsHockeyIcon />,
  "Mixed Martial Arts": <SportsMmaIcon />,
  "Rugby League": <SportsRugbyIcon />,
  "Rugby Union": <SportsRugbyIcon />,
  Soccer: <SportsSoccerIcon />,
  Tennis: <SportsTennisIcon />,
};

export function getSportsIcon(sport) {
  return sport && sportsIcons[sport] ? sportsIcons[sport] : null;
}

const teamLogos = {
  Adelaide:
    "https://www.footyalmanac.com.au/wp-content/uploads/2019/02/adelaide-crows-logo.png",
  Brisbane:
    "https://www.footyalmanac.com.au/wp-content/uploads/2019/02/brisbane-lions-logo.png",
  Carlton:
    "https://www.footyalmanac.com.au/wp-content/uploads/2019/02/carlton-blues-logo.png",
  Collingwood:
    "https://www.footyalmanac.com.au/wp-content/uploads/2019/02/collingwood-magpies-logo.png",
  Essendon:
    "https://www.footyalmanac.com.au/wp-content/uploads/2019/02/essendon-bombers-logo.png",
  Fremantle:
    "https://www.footyalmanac.com.au/wp-content/uploads/2019/02/fremantle-dockers-logo.png",
  Geelong:
    "https://www.footyalmanac.com.au/wp-content/uploads/2019/02/geelong-cats-logo.png",
  "Gold Coast":
    "https://www.footyalmanac.com.au/wp-content/uploads/2019/02/gold-coast-suns-logo.png",
  GWS: "https://www.footyalmanac.com.au/wp-content/uploads/2019/02/gws-giants-logo.png",
  Hawthorn:
    "https://www.footyalmanac.com.au/wp-content/uploads/2019/02/hawthorn-hawks-logo.png",
  Melbourne:
    "https://www.footyalmanac.com.au/wp-content/uploads/2019/02/melbourne-demons-logo.png",
  "North Melbourne":
    "https://www.footyalmanac.com.au/wp-content/uploads/2019/02/north-melbourne-kangaroos-logo.png",
  "Port Adelaide":
    "https://www.footyalmanac.com.au/wp-content/uploads/2019/02/port-adelaide-power-logo.png",
  Richmond:
    "https://www.footyalmanac.com.au/wp-content/uploads/2019/02/richmond-tigers-logo.png",
  "St Kilda":
    "https://www.footyalmanac.com.au/wp-content/uploads/2019/02/st-kilda-saints-logo.png",
  Sydney:
    "https://www.footyalmanac.com.au/wp-content/uploads/2019/02/sydney-swans-logo.png",
  "West Coast":
    "https://www.footyalmanac.com.au/wp-content/uploads/2019/02/west-coast-eagles-logo.png",
  "Western Bulldogs":
    "https://www.footyalmanac.com.au/wp-content/uploads/2019/02/western-bulldogs-logo.png",
};

export const getTeamLogoSrc = (teamName) => teamLogos[teamName] || "";

export const notBookieValues = ["best-avg", "avg-ods", "best-odds"];

export const marketsOptions = ["Match Odds", "Over/Under 2.5 Goals"];

export const marketsOptionsPremiumPlus = [
  ...marketsOptions,
  "Over/Under 1.5 Goals",
  "Over/Under 3.5 Goals",
  "Over/Under 4.5 Goals",
  "Over/Under 5.5 Goals",
  "1st Half Over/Under 0.5 Goals",
  "1st Half Over/Under 1.5 Goals",
  "1st Half Over/Under 2.5 Goals",
  "1st Half Over/Under 3.5 Goals",
  "1st Half Winner",
  "Draw No Bet",
  "Both Teams To Score",
];

export const marketsOptionsPro = [
  ...marketsOptionsPremiumPlus,
  "Line",
  "Total Points",
  "1st Half Line",
  "1st Half Total Points",
  "Player 3's",
  "Player Points",
  "Player Rebounds",
  "Player Assists",
  "Player Steals",
  "Player Blocks",
  "Player Disposals",
  "Player Assists & Rebounds",
  "Player Points & Assists",
  "Player Points & Rebounds",
  "Points, Rebounds & Assists",
  "Player Triple Double",
  "Player Double Double",
  "Player Shots",
  "Player Shots on Target",
  "Player Pass Attempts",
  "Player Receptions",
  "Player Rush Attempts",
  "Player Turnovers",
  "Match Odds X Double Chance",
  "Total Games",
];
